import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const loc = useLocation();
  const nav = useNavigate();
  const { t } = useI18n();
  const params = new URLSearchParams(loc.search);
  const session_id = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session_id) return;
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (stop) return;
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 20) {
          setTimeout(() => setTries((n) => n + 1), 2000);
        }
      } catch (e) {
        // ignore — will retry on next poll
      }
    };
    poll();
    return () => { stop = true; };
  }, [session_id, tries]);

  return (
    <div className="min-h-screen grid place-items-center p-6 grain-bg">
      <Card className="w-full max-w-lg rounded-2xl">
        <CardContent className="p-8 text-center">
          <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-primary/10 text-primary">
            <CheckCircle2 className="h-7 w-7" />
          </div>
          <h1 className="font-display text-3xl font-bold">
            {status.payment_status === "paid" ? "Payment received" : "Confirming payment…"}
          </h1>
          {status.package_name && <p className="mt-2 text-muted-foreground">{status.package_name}</p>}
          {status.amount && (
            <div className="mt-4 num text-4xl font-semibold">
              {(status.currency || "").toUpperCase()} {Number(status.amount).toFixed(2)}
            </div>
          )}
          <Button
            className="mt-6 rounded-full h-11"
            onClick={() => nav("/parent/payments")}
            data-testid="pay-success-back"
          >
            Back to payments
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center p-6 grain-bg">
      <Card className="w-full max-w-lg rounded-2xl">
        <CardContent className="p-8 text-center">
          <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-destructive/10 text-destructive">
            <XCircle className="h-7 w-7" />
          </div>
          <h1 className="font-display text-3xl font-bold">Payment cancelled</h1>
          <p className="mt-2 text-muted-foreground">No charge was made.</p>
          <Link to="/parent/payments"><Button className="mt-6 rounded-full h-11" data-testid="pay-cancel-back">Back</Button></Link>
        </CardContent>
      </Card>
    </div>
  );
}
